/* ============================================================
   RECVR landing — interactions (Shopify, idempotent)
   Safe to load once per section; re-running only (re)binds
   un-bound nodes. One-time timers are globally guarded.
   ============================================================ */
(function () {
  "use strict";

  // The <script> tag may appear in several sections; an external script with
  // the same src executes once per tag. Guard one-time setup but still allow
  // re-boot for sections added later in the theme editor.
  if (window.__RECVR__ && window.__RECVR__.loaded) { window.__RECVR__.boot(); return; }

  var BOUND = "data-recvr-bound";

  /* ---------- FAQ accordion (accessible) ---------- */
  function initFaq(root) {
    root.querySelectorAll(".faq-item").forEach(function (item) {
      var q = item.querySelector(".faq-q");
      var a = item.querySelector(".faq-a");
      if (!q || !a || q.getAttribute(BOUND)) return;
      q.setAttribute(BOUND, "1");
      q.setAttribute("aria-expanded", item.classList.contains("open") ? "true" : "false");
      if (item.classList.contains("open")) a.style.maxHeight = a.scrollHeight + "px";
      q.addEventListener("click", function () {
        var list = item.closest(".faq-list") || root;
        var isOpen = item.classList.contains("open");
        list.querySelectorAll(".faq-item.open").forEach(function (o) {
          o.classList.remove("open");
          var oa = o.querySelector(".faq-a"); if (oa) oa.style.maxHeight = null;
          var oq = o.querySelector(".faq-q"); if (oq) oq.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item.classList.add("open");
          a.style.maxHeight = a.scrollHeight + "px";
          q.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  /* ---------- Countdown (per page, shared deadline) ---------- */
  var cdStarted = false;
  function initCountdown() {
    if (cdStarted) { tickCd(); return; }
    cdStarted = true;
    tickCd();
    setInterval(tickCd, 1000);
  }
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function tickCd() {
    var KEY = "recvr_deadline_v2";
    var box = document.querySelector(".recvr [data-recvr-countdown]");
    var windowMs = 0;
    if (box) windowMs = (parseInt(box.getAttribute("data-window-min"), 10) || 351) * 60000;
    if (!windowMs) windowMs = 351 * 60000;
    var deadline = parseInt(localStorage.getItem(KEY) || "0", 10);
    var now = Date.now();
    if (!deadline || deadline < now) { deadline = now + windowMs; localStorage.setItem(KEY, String(deadline)); }
    var diff = Math.max(0, deadline - Date.now());
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    set('[data-cd="d"]', pad(d)); set('[data-cd="h"]', pad(h));
    set('[data-cd="m"]', pad(m)); set('[data-cd="s"]', pad(s));
    var clock = pad(h + d * 24) + ":" + pad(m) + ":" + pad(s);
    document.querySelectorAll(".recvr .order-clock, .recvr #recvr-sticky-cd").forEach(function (el) { el.textContent = clock; });
  }
  function set(sel, val) { document.querySelectorAll(".recvr " + sel).forEach(function (el) { el.textContent = val; }); }

  /* ---------- Bundle selection + steppers (Appstle form handles the add) ---------- */
  function initBundles(root) {
    var section = root.querySelector("[data-recvr-bundles]");
    if (!section) return;
    var cards = Array.prototype.slice.call(section.querySelectorAll(".sub-card"));
    var sNow = document.getElementById("recvr-sticky-now");
    var sWas = document.getElementById("recvr-sticky-was");
    var sLabel = document.getElementById("recvr-sticky-label");

    function selectCard(c) {
      cards.forEach(function (x) { x.classList.remove("active"); });
      c.classList.add("active");
      var valEl = c.querySelector(".qty-val");
      var qty = valEl ? parseInt(valEl.textContent, 10) : 1;
      var unit = parseFloat(c.getAttribute("data-price")) || 0;
      if (sNow) sNow.textContent = c.getAttribute("data-cur") + (unit * qty).toFixed(2);
      if (sWas) {
        var was = c.getAttribute("data-was");
        if (was) { sWas.textContent = c.getAttribute("data-cur") + (parseFloat(was) * qty).toFixed(2); sWas.style.display = ""; }
        else sWas.style.display = "none";
      }
      if (sLabel) {
        var pill = c.getAttribute("data-pill");
        if (pill) sLabel.innerHTML = '<span class="save-pill">' + pill + "</span>" + (c.getAttribute("data-rest") || "");
        else sLabel.textContent = c.getAttribute("data-label") || "";
      }
    }

    cards.forEach(function (c) {
      if (!c.getAttribute(BOUND)) {
        c.setAttribute(BOUND, "1");
        c.addEventListener("click", function (e) {
          if (e.target.closest(".stepper") || e.target.closest(".add-cart") || e.target.closest(".g-arrow") || e.target.closest(".g-thumb")) return;
          selectCard(c);
        });
        var valEl = c.querySelector(".qty-val");
        var priceEl = c.querySelector(".qty-price");
        var unit = parseFloat(c.getAttribute("data-price")) || 0;
        var was = c.getAttribute("data-was") ? parseFloat(c.getAttribute("data-was")) : null;
        var cur = c.getAttribute("data-cur") || "£";
        function renderPrice() {
          if (!valEl) return;
          var q = parseInt(valEl.textContent, 10);
          var qi = c.querySelector('input[name="quantity"]'); if (qi) qi.value = q;
          if (!priceEl) return;
          var html = "";
          if (was) html += "<s>" + cur + (was * q).toFixed(2) + "</s> ";
          html += "<b>" + cur + (unit * q).toFixed(2) + "</b>";
          priceEl.innerHTML = html;
          if (c.classList.contains("active")) selectCard(c);
        }
        var dec = c.querySelector(".stepper .dec"), inc = c.querySelector(".stepper .inc");
        if (dec) dec.addEventListener("click", function (e) { e.stopPropagation(); valEl.textContent = Math.max(1, parseInt(valEl.textContent, 10) - 1); renderPrice(); });
        if (inc) inc.addEventListener("click", function (e) { e.stopPropagation(); valEl.textContent = Math.min(10, parseInt(valEl.textContent, 10) + 1); renderPrice(); });
      }
    });

    var initActive = section.querySelector(".sub-card.active") || cards[0];
    if (initActive) selectCard(initActive);
  }

  /* ---------- Bundle image gallery (arrows, thumbs, swipe) ---------- */
  function initGallery(root) {
    root.querySelectorAll("[data-gallery]").forEach(function (g) {
      if (g.getAttribute(BOUND)) return;
      g.setAttribute(BOUND, "1");
      var slides = Array.prototype.slice.call(g.querySelectorAll(".gslide"));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll(".g-thumb"));
      if (!slides.length) return;
      var idx = 0;
      function show(i) {
        var n = slides.length;
        idx = (i % n + n) % n;
        slides.forEach(function (s, si) { s.classList.toggle("active", si === idx); });
        thumbs.forEach(function (t, ti) { t.classList.toggle("active", ti === idx); });
      }
      var prev = g.querySelector("[data-gprev]");
      var next = g.querySelector("[data-gnext]");
      if (prev) prev.addEventListener("click", function (e) { e.stopPropagation(); show(idx - 1); });
      if (next) next.addEventListener("click", function (e) { e.stopPropagation(); show(idx + 1); });
      thumbs.forEach(function (t, ti) { t.addEventListener("click", function (e) { e.stopPropagation(); show(ti); }); });

      var media = g.querySelector(".sub-media");
      if (media) {
        var x0 = null, y0 = null;
        media.addEventListener("touchstart", function (e) { var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
        media.addEventListener("touchend", function (e) {
          if (x0 === null) return;
          var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(idx + (dx < 0 ? 1 : -1)); }
          x0 = null; y0 = null;
        }, { passive: true });
      }
      show(0);
    });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  var stickyBound = false;
  function initSticky() {
    var sticky = document.getElementById("recvr-sticky");
    if (!sticky || stickyBound) { onScroll(); return; }
    stickyBound = true;
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }
  function onScroll() {
    var sticky = document.getElementById("recvr-sticky");
    var hero = document.querySelector(".recvr .hero");
    var bundle = document.querySelector(".recvr [data-recvr-bundles]");
    if (!sticky) return;
    var pastHero = hero ? window.scrollY > hero.offsetHeight - 80 : window.scrollY > 600;
    var inBundle = false;
    if (bundle) { var r = bundle.getBoundingClientRect(); inBundle = r.top < window.innerHeight && r.bottom > 0; }
    var atFooter = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 60);
    if (pastHero && !inBundle && !atFooter) sticky.classList.add("show");
    else sticky.classList.remove("show");
  }

  /* ---------- Video testimonials carousel dots (mobile) ---------- */
  function initVtest(root) {
    root.querySelectorAll(".vtest-track").forEach(function (track) {
      if (track.getAttribute(BOUND)) return;
      track.setAttribute(BOUND, "1");
      var dots = track.parentElement.querySelector(".vtest-dots");
      if (!dots) return;
      dots.innerHTML = "";
      var cards = track.querySelectorAll(".vtest-card");
      cards.forEach(function (card, i) {
        var b = document.createElement("button");
        b.type = "button"; if (i === 0) b.className = "on";
        b.addEventListener("click", function () { card.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" }); });
        dots.appendChild(b);
      });
      var dotEls = dots.querySelectorAll("button");
      track.addEventListener("scroll", function () {
        var center = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
        cards.forEach(function (c, i) { var cc = c.offsetLeft + c.offsetWidth / 2, dd = Math.abs(cc - center); if (dd < bd) { bd = dd; best = i; } });
        dotEls.forEach(function (d, i) { d.classList.toggle("on", i === best); });
      }, { passive: true });
    });
  }

  /* ---------- Video testimonials: inline play / tap-to-pause ---------- */
  function initVtestVideo(root) {
    root.querySelectorAll("[data-vt-media]").forEach(function (media) {
      if (media.getAttribute(BOUND)) return;
      var video = media.querySelector("[data-vt-video]");
      if (!video) return;
      media.setAttribute(BOUND, "1");
      var card = media.closest(".vtest-card");
      media.addEventListener("click", function (e) {
        e.preventDefault();
        if (video.paused) {
          document.querySelectorAll(".recvr .vt-video").forEach(function (v) { if (v !== video && !v.paused) v.pause(); });
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
      video.addEventListener("play", function () { if (card) card.classList.add("vt-playing"); });
      video.addEventListener("pause", function () { if (card) card.classList.remove("vt-playing"); });
      video.addEventListener("ended", function () { if (card) { card.classList.remove("vt-playing"); video.currentTime = 0; } });
    });
  }

  /* ---------- Smooth scroll for in-page anchors (CTAs, nav, sticky bar) ---------- */
  function initAnchors(root) {
    root.querySelectorAll(".recvr a[href^='#']").forEach(function (a) {
      if (a.getAttribute(BOUND)) return;
      var href = a.getAttribute("href");
      if (!href || href === "#") return;
      a.setAttribute(BOUND, "1");
      a.addEventListener("click", function (e) {
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector(".recvr .recvr-stick");
        var offset = (header ? header.offsetHeight : 0) + 8;
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
      });
    });
  }

  /* ---------- Scroll reveal (IntersectionObserver — smooth, no scroll jank) ---------- */
  var revealIO = null;
  function initReveal() {
    var nodes = document.querySelectorAll(".recvr .reveal:not(.in)");
    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (el) { el.classList.add("in"); });
      document.querySelectorAll(".recvr").forEach(function (el) { el.classList.add("reveal-armed"); });
      return;
    }
    // Pre-reveal anything already in the viewport BEFORE arming, so above-the-fold
    // content (hero, header) never flashes visible -> hidden -> visible on load.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    nodes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add("in");
    });
    document.querySelectorAll(".recvr").forEach(function (el) { el.classList.add("reveal-armed"); });
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("in"); revealIO.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.04 });
    }
    document.querySelectorAll(".recvr .reveal:not(.in)").forEach(function (el) { revealIO.observe(el); });
  }

  /* ---------- Cart line items link to the home page (slide cart + cart page) ---------- */
  function initCartLinks() {
    function fix(scope) {
      (scope || document).querySelectorAll("a.cart-item__link, a.cart-item__name").forEach(function (a) {
        a.setAttribute("href", "/");
      });
    }
    fix(document);
    var dc = document.querySelector("cart-drawer");
    if (dc && !dc.getAttribute(BOUND)) {
      dc.setAttribute(BOUND, "1");
      try {
        new MutationObserver(function () { fix(dc); }).observe(dc, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  /* ---------- Boot ---------- */
  function initHeader(root) {
    var hb = root.querySelector("[data-recvr-hamburger]");
    var mm = root.querySelector("[data-recvr-menu]");
    if (!hb || !mm || hb.getAttribute(BOUND)) return;
    hb.setAttribute(BOUND, "1");
    function openMenu() { mm.classList.add("open"); hb.setAttribute("aria-expanded", "true"); document.body.style.overflow = "hidden"; }
    function closeMenu() { mm.classList.remove("open"); hb.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; }
    hb.addEventListener("click", openMenu);
    root.querySelectorAll("[data-recvr-mm-close]").forEach(function (b) { b.addEventListener("click", closeMenu); });
    mm.querySelectorAll(".mm-nav a, .mm-cta").forEach(function (a) { a.addEventListener("click", closeMenu); });
  }

  function boot() {
    var root = document;
    document.querySelectorAll(".recvr").forEach(function () {});
    initHeader(root);
    initFaq(root);
    initGallery(root);
    initBundles(root);
    initVtest(root);
    initVtestVideo(root);
    initAnchors(root);
    initCartLinks();
    if (document.querySelector(".recvr [data-recvr-countdown]")) initCountdown();
    initSticky();
    initReveal();
  }

  window.__RECVR__ = { loaded: true, boot: boot };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // Shopify theme editor: re-init when a section is loaded/reordered
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);
})();
